import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { deleteVisitProfile, getvisitProfile } from "../../actions/userActions/VisitProfileAction";
import SearchInput from "../subComponents/search/SearchInput";
import CustomButton from "../subComponents/buttons/CustomButton";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CustomPagination from "../subComponents/pagination/CustomPagination";
import Heading6Regular from "../designSystem/Heading6Regular";
import './VisitProfile.css';
import deleteIcon from "../../assets/images/deleteIcon_drawer.svg";
import Heading6Semibold from "../designSystem/Heading6Semibold";
import BodyMediumRegular from "../designSystem/BodyMediumRegular";
import BodyExtraSmallMedium from "../designSystem/BodyExtraSmallMedium";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import thIcon from "../../assets/images/thIcon.svg";
import DynamicTable from "../reuse_components/DynamicTable";
const VisitProfile = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [selectedVisitProfileId, setSelectedVisitProfileId] = useState(null);
    const itemsPerPage = 10;
    const visitProfile = useSelector((state) => state.visitProfile_reducer.visitProfile);
    const permissions = JSON.parse(localStorage.getItem("permissionsList"));

    useEffect(() => {
        dispatch(getvisitProfile(currentPage, itemsPerPage, searchQuery));
    }, [dispatch, currentPage, searchQuery]);

    const handleCancelDelete = () => {
        setOpenModal(false);
        setSelectedVisitProfileId(null);
    };

    const handleConfirmDelete = () => {
        if (selectedVisitProfileId) {
            dispatch(deleteVisitProfile(selectedVisitProfileId)).then(() => {
                dispatch(getvisitProfile(currentPage, itemsPerPage, searchQuery));
            });
        }
        setOpenModal(false);
        setSelectedVisitProfileId(null);
    };

    const handleOpenModal = (row) => { 
        setSelectedVisitProfileId(row.visitProfileId);
        setOpenModal(true);
    };
    const handleEditVisitProfile = (row) => {
        history.push({
          pathname: "/admin/UpdateVisitProfile",
          visitProfile: { row },
          id: row.visitProfileId,
        });
      };
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const handleAddVisitProfileClick = () => {
        history.push("/admin/AddVisitProfile");
    };
    const visitProfileData = visitProfile?.result || [];
    const totalPages = visitProfile?.totalPages || 0;
    const totalItems = visitProfile?.totalCount || 0;

    const columns = [
        { label: ' Name', accessor: 'systemGeneratedName' },
        { label: ' Display Name', accessor: 'profileName' },
        { label: 'City', accessor: 'cityName' },
       
    ];
    const actions = [
        {
            label: 'Delete Visit Profile',
            icon: <DeleteOutlineIcon />,
            permission: 'CanDeleteVisitProfile',
            handler: handleOpenModal,
        },
        {
            label: 'Edit Visit Profile',
            icon: <EditOutlinedIcon />,
            permission: 'CanUpdateVisitProfile',
            handler:handleEditVisitProfile,
        },
    ];

    return (
        <>
         <div>
      <div className="main-container">
            <div className="content-header">
                <div className="header-navigation">
                    <BodySmallMedium text="Manage" color="#A1A2A4" />
                    <img
                        src={chevron_rightIcon} alt="Chevron Right" className="chevron-right-icon" />
                    <BodySmallMedium text="Visit Profile" color="#1E293B" />
                </div>
            </div>
            <Heading6Regular text="Visit Profile" color="#1E293B" />
            <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
              value={searchQuery}
                    />
                    <div style={{ display: "flex", alignItems: "center" }}>
                       <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                {permissions && permissions.includes("CanAddVisitProfile") && (
                         <CustomButton text="Add Visit Profile" width="180px" onClick={handleAddVisitProfileClick} />
                     )}
                    </div>
                </div>
                         <DynamicTable
                    data={visitProfileData}
                    isLoading={visitProfile === "isLoading"}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                />
                     <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
    {totalItems > 0 && (
      <CustomPagination
        currentPage={currentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        totalPages={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
      />
    )}
    </div>
            </div>

        </div>
             {openModal && (
                <div className="modal-backdrop">
                    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                        <div className='content-container'>
                            <div className='icon-container'>
                                <img src={deleteIcon} />
                            </div>
                            <div className='text-container'>
                                <Heading6Semibold color='#1E293B' text='Delete Visit Profile' />
                                <BodyMediumRegular
                                    color='#384153'
                                    text='Are you sure you want to delete this visit profile?'
                                    textAlign='center'
                                />
                            </div>
                        </div>
                        <div className='button-contiainer'>
                            <button className='cancel-button' onClick={handleCancelDelete}>
                                <BodyExtraSmallMedium color='#1E293B' text='Cancel' />
                            </button>
                            <button className='danger-button' onClick={handleConfirmDelete}>
                                <BodyExtraSmallMedium color='#FFFFFF' text='Delete' />
                            </button>
                        </div>
                    </div>
                </div>
             )}
      </div>
        </>
    );
};

export default VisitProfile;
